export default __webpack_public_path__ + "static/media/Presidente.cdef7d9d.jpg";